<div #root [class.disabled]="disabled"
     [class.editable]="editable"
     [class.error]="invalid"
     [class.icon]="iconName"
     [class.readonly]="readonly"
     [class.table-input]="tableInput"
     [class.with-label]="label && iconName"
     [style.max-width]="maxWidth + 'px'"
     [style.width]="width + 'px'"
     class="work-ui-select work-input">
  @if (label) {
    <label>
      <ng-template #labelContent>
        <b>{{ label | translate }}
          @if (required) {
            <b class="work-text-required-asterisk"> *</b>
          }</b>
      </ng-template>

      @switch (labelSize) {
        @case ('small') {
          <small>
            <ng-container *ngTemplateOutlet="labelContent" />
          </small>
        }
        @case ('default') {
          <p>
            <ng-container *ngTemplateOutlet="labelContent" />
          </p>
        }
      }
    </label>
  }
  <div class="input-wrapper">
    <div #customSelect (click)="focusOnSelect()"
         [class.disabled]="disabled"
         [class.readonly--no-borders]="readonlyNoBorders"
         [class.readonly]="readonly"
         [class.clearable]="valueClearable && !readonly && !disabled && value !== null && value !== undefined && value !== ''"
         [style.min-width]="width + 'px'"
         class="work-ui-select__custom"
         tabindex="0">
      <div [class.placeholder]="!value" class="work-ui-select__selected-option">
        <p class="work-ui-select__selected-option-text">{{ selectedLabel | translate }}</p>
      </div>
      <select #nativeSelect
              (change)="emitValueChange($event)"
              [disabled]="disabled"
              [name]="name"
              [value]="value"
      data-testid="select__native-input">
        <option [value]="placeholder">{{ placeholder | translate }}</option>
        @for (option of options; track $index) {
          <option
            [selected]="option.value === value"
            [value]="option.value">
            {{ option.label | translate }}
          </option>
        }
      </select>
      @if (valueClearable && !readonly && !disabled && value !== null && value !== undefined && value !== '') {
        <!-- Schlichtes «×» vor dem Pfeil, vertikal zentriert — kein Button-Rahmen, der über dem Text liegt. -->
        <button (actionConfirmResult)="emitValueCleared()"
                (click)="$event.stopPropagation()"
                [attr.aria-label]="'AUSWAHL_ENTFERNEN' | translate"
                class="clear-value"
                type="button"
                workUiShowConfirmActionModal>
          <work-ui-icon [fontSize]="18" name="close" />
        </button>
      }
      <work-ui-icon class="arrow-down" name="expand_more" />
    </div>
    @if (iconName) {
      <work-ui-icon [name]="iconName" />
    }
  </div>
  @if (!disableHint) {
    <span [class.hide]="hideHint" [style.opacity]="invalid ? '1' : '0'" class="work-input__hint">
      <small><b>{{ hintMessage | translate }}</b></small>
    </span>
  }
</div>
